<template>
  <v-form
    v-model="valid"
    ref="form"
    lazy-validation
    class="pr-md-24"
    @submit.prevent="createCategory"
  >
    <div class="d-flex justify-end mb-2">
      <v-btn
        tile
        color="primary"
        @click="$router.push({ name: 'category-index' })"
      >
        <v-icon left>
          arrow_back
        </v-icon>
        Back
      </v-btn>
    </div>
    <v-card elevation="0" outlined class="pr-md-24 pl-md-4 mb-10 pt-4">
      <v-container>
        <v-row class="mb-2">
          <v-col cols="12">
            <div class="text-left">
              <h4 class="back--text gotham-book">General Information</h4>
            </div>
          </v-col>
          <v-col class="text-center" cols="12" md="6">
            <v-text-field
              :counter="35"
              label="Name"
              outlined
              v-model="category.name"
              :rules="nameRules"
            ></v-text-field>
          </v-col>
          <v-col cols="0" md="6"></v-col>
          <v-col cols="12" md="6">
            <v-textarea
              :counter="200"
              outlined
              label="Description"
              :rules="descriptionRules"
              v-model="category.description"
              required
            ></v-textarea>
          </v-col>
          <v-col cols="6"></v-col>
          <v-col class="text-left">
            <v-btn type="submit" color="accent">Create</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-form>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      valid: false,
      category: {
        name: "",
        description: ""
      },
      nameRules: [
        v => !!v || "Name is required",
        v => v.length >= 3 || "Name must be at least 3 characters",
        v => v.length <= 35 || "Name must be less than than 35 characters"
      ],
      descriptionRules: [
        v => !!v || "Description is required",
        v => v.length >= 3 || "Description must be at least 3 characters",
        v =>
          v.length <= 200 || "Description must be less than than 200 characters"
      ]
    };
  },
  methods: {
    async createCategory() {
      if (this.$refs.form.validate()) {
        this.$swal({
          title: "Adding Category...",
          html: "this will only take a moment...",
          icon: "info",
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("categories/CREATE_CATEGORY", this.category);
        this.$swal.close();
        this.$swal({
          title: "Success",
          html: "Category has been added",
          icon: "info"
        });
      }
    }
  }
};
</script>
